import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mix-control" }
const _hoisted_2 = { class: "mix-control-start-stop" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "mix-control-clock" }
const _hoisted_5 = { class: "mix-control-tempo" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mix-control-timeline btn-group" }
const _hoisted_8 = { class: "mix-control-name" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  ref: "trackPicker",
  class: "mix-control-tracks"
}
const _hoisted_11 = {
  key: 0,
  class: "mix-control-tracks-add"
}
const _hoisted_12 = {
  key: 0,
  title: "Mix has unsaved properties",
  class: "mix-control-unsaved"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_backward_icon = _resolveComponent("backward-icon")!
  const _component_clock_icon = _resolveComponent("clock-icon")!
  const _component_pause_icon = _resolveComponent("pause-icon")!
  const _component_play_icon = _resolveComponent("play-icon")!
  const _component_track_picker = _resolveComponent("track-picker")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_exclamation_triangle_icon = _resolveComponent("exclamation-triangle-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.rewind && _ctx.rewind(...args))),
        class: "btn-outline btn-sq"
      }, [
        _createVNode(_component_backward_icon)
      ]),
      _createElementVNode("button", {
        disabled: _ctx.isDecoding,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
        class: "btn-outline btn-sq"
      }, [
        (_ctx.isDecoding)
          ? (_openBlock(), _createBlock(_component_clock_icon, { key: 0 }))
          : (_ctx.isPlaying)
            ? (_openBlock(), _createBlock(_component_pause_icon, { key: 1 }))
            : (_openBlock(), _createBlock(_component_play_icon, { key: 2 }))
      ], 8, _hoisted_3)
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mix-control-vr" }, null, -1)),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.clock), 1),
    _createElementVNode("div", _hoisted_5, [
      _cache[7] || (_cache[7] = _createTextVNode(" BPM ", -1)),
      _createElementVNode("input", {
        class: "input",
        type: "number",
        value: _ctx.mix.tempo,
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTempoChange && _ctx.onTempoChange(...args)))
      }, null, 40, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('timeline-type', 'time'))),
        class: _normalizeClass(["btn-outline", { active: _ctx.timelineType === 'time' }])
      }, " Time ", 2),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('timeline-type', 'bar'))),
        class: _normalizeClass(["btn-outline", { active: _ctx.timelineType === 'bar' }])
      }, " Bar ", 2)
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mix-control-vr" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(_toDisplayString(_ctx.project.name) + " Mix v" + _toDisplayString(_ctx.mix.version) + " ", 1),
      _createElementVNode("input", {
        class: "input",
        type: "text",
        placeholder: "Description",
        value: _ctx.mix.description,
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDescriptionChange && _ctx.onDescriptionChange(...args)))
      }, null, 40, _hoisted_9)
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mix-control-vr" }, null, -1)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showTrackPicker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_track_picker, {
                  onAdd: _ctx.onAddTrack,
                  onAddAll: _ctx.onAddAllTracks
                }, null, 8, ["onAdd", "onAddAll"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showTrackPicker = true), ["prevent","stop"])),
        class: "mix-control-tracks-btn"
      }, [
        _createVNode(_component_plus_icon),
        _cache[8] || (_cache[8] = _createTextVNode(" Add Tracks", -1))
      ])
    ], 512),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mix-control-space" }, null, -1)),
    (_ctx.mixPropsDirty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_exclamation_triangle_icon)
        ]))
      : _createCommentVNode("", true)
  ]))
}